import { FormErrorCode } from "../entities/FormErrorCode";

export function mapErrorCodesToErrorDescription(
    errorCode: string,
    failoverText: string
): string {
    if (errorCode === "noDoctorInsuranceGroup1") {
        return "I CPR har borgeren ikke tilknyttet en læge. Borgeren modtager et brev i Digital Post med videre instruktioner.";
    }
    if (errorCode === "insuranceGroup2") {
        return "Borgeren er i sygesikringsgruppe 2, og har ikke tilknyttet en læge. Borgeren modtager et brev i Digital Post med videre instruktioner.";
    }
    switch (Number(errorCode)) {
        case FormErrorCode.CprLookupError:
            return "Der har været en fejl i opslag af yder nr. på CPR. Kontakt applikationssupporten ved Færdselsstyrelsen.";
        case FormErrorCode.ClinicLookupError:
            return "Der har været en fejl i opslag af tilknyttet læge. Kontakt applikationssupporten ved Færdselsstyrelsen.";
        case FormErrorCode.DigitalPostReceiver:
            return failoverText;
        case FormErrorCode.DigitalPostSender:
            return failoverText;
        case FormErrorCode.UnknownError:
        case FormErrorCode.InvalidDataFromVirk:
        case FormErrorCode.UnknownXmlFormat:
        case FormErrorCode.MissingMunicipalityCodeInXml:
        case FormErrorCode.MissingCitizeninfoFromXml:
        case FormErrorCode.NameNotFound:
        case FormErrorCode.LastNameNotFound:
        case FormErrorCode.NameInvalid:
        case FormErrorCode.ResourceNotFound:
        case FormErrorCode.CaseNotFetched:
        case FormErrorCode.GpSystemCredentials:
        case FormErrorCode.ReceivingFromGpSystem:
        case FormErrorCode.InvalidDataFromGpSystem:
        case FormErrorCode.ThirdPartyError:
        case FormErrorCode.NoSenderToDoctor:
        default:
            return "Det har ikke været muligt at identificere fejlen. Kontakt applikationssupporten ved Færdselsstyrelsen.";
    }
}
